import "./App.css";
import React, { useEffect } from "react";
import ReactGA from "react-ga";

// import PhoneVerification from './components/phone/PhoneVerification'
// import CreateAccFrom from "./components/phone/CreateAccForm";
// import ForgotPassword from './components/phone/ForgotPassword'
// import Signin from './components/phone/signin'
// import Verifynum from './components/phone/verifynum'
// import Restpass from './components/phone/resetpass'
// import Otp from './components/phone/otp'
// import Authtwo from './components/phone/authtwo'
import CacheBuster from "./CacheBuster";
import Routes from "./Routes";
import { PersistGate } from "redux-persist/integration/react";
import store from "./redux/store";
import * as Sentry from "@sentry/react";
import FallbackComponent from "./components/FallbackComponent";

import { Provider } from "react-redux";
import {
  MuiThemeProvider,
  createMuiTheme,
  responsiveFontSizes,
} from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import CssBaseline from "@material-ui/core/CssBaseline";
import { BrowserRouter as Router, useLocation } from "react-router-dom";
import { SnackbarProvider } from "notistack";
import { useHistory } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import usePageTracking from "./services/usePageTracking";
import createHistory from "history/createBrowserHistory";
import { QueryClient, QueryClientProvider } from "react-query";
import DialogProvider from "./contexts/DialogProvider";
import { persistStore } from "redux-persist";
import Root from "./components/Root";

process.env["REACT_APP_PROD_URL"] = "https://api2.pocketbits.in/api";

let persistor = persistStore(store);

if (!localStorage.getItem("mode")) {
  localStorage.setItem("mode", JSON.stringify({ dark: true }));
}

if (!localStorage.getItem("list")) {
  localStorage.setItem("list", JSON.stringify({ favList: [] }));
}

var modeL = JSON.parse(localStorage.getItem("mode"));

let theme = createMuiTheme({
  palette: {
    primary: {
      main: "#3AC4AB",
    },
    secondary: {
      main: "#ffffff",
    },
    background: {
      default: modeL.dark ? "#000" : "#F7F7F7",
    },
    type: modeL.dark ? "dark" : "light",
  },
  status: {
    danger: "orange",
  },
});
theme = responsiveFontSizes(theme);

export default function App() {
  // usePageTracking();

  var channel =
    process.env.NODE_ENV === "development"
      ? "cryptoinr-websocket"
      : "cradex-development";

  const notistackRef = React.createRef();
  const onClickDismiss = (key) => () => {
    notistackRef.current.closeSnackbar(key);
  };

  const [queryClient] = React.useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            refetchOnWindowFocus: false,
            retry: false,
            // cacheTime: 0,
          },
        },
      })
  );
  return (
    <>
      <CacheBuster>
        {({ loading, isLatestVersion, refreshCacheAndReload }) => {
          if (loading) return null;
          if (!loading && !isLatestVersion) {
            // You can decide how and when you want to force reload
            refreshCacheAndReload();
          }

          return (
            <QueryClientProvider client={queryClient}>
              <Provider store={store}>
                <PersistGate loading={null} persistor={persistor}>
                  <MuiThemeProvider theme={theme}>
                    <Sentry.ErrorBoundary
                      fallback={FallbackComponent}
                      beforeCapture={(scope) => {
                        console.log("errorboundary", scope);
                        scope.setTag("type", "crash");
                      }}
                    >
                      <CssBaseline>
                        <SnackbarProvider
                          maxSnack={3}
                          ref={notistackRef}
                          action={(key) => (
                            <IconButton onClick={onClickDismiss(key)}>
                              <CloseIcon fontSize="small" />
                            </IconButton>
                          )}
                        >
                          <DialogProvider>
                            <Root>
                              <Router>
                                <Routes />
                              </Router>
                            </Root>
                          </DialogProvider>
                        </SnackbarProvider>
                      </CssBaseline>{" "}
                    </Sentry.ErrorBoundary>
                  </MuiThemeProvider>
                </PersistGate>
              </Provider>
            </QueryClientProvider>
          );
        }}
      </CacheBuster>
    </>
  );
}
